import { render, staticRenderFns } from "./SignUpMultiselectLight.vue?vue&type=template&id=6dfc2a8c&scoped=true"
import script from "./SignUpMultiselectLight.vue?vue&type=script&lang=js"
export * from "./SignUpMultiselectLight.vue?vue&type=script&lang=js"
import style0 from "./SignUpMultiselectLight.vue?vue&type=style&index=0&id=6dfc2a8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfc2a8c",
  null
  
)

export default component.exports